import { IllumioEventEmitter } from "../common/event_emitter.js";
import SoftwareUtils from "./common-utils.js";
import { CustomDownloadModel, CustomDownloadView, CustomDownloadController } from "./custom-download-mvc.js";
import { SoftwareDownloadModel, SoftwareDownloadView, SoftwareDownloadController } from "./download-mvc.js";
import { SoftwareUpgradeModel, SoftwareUpgradeView, SoftwareUpgradeController } from "./upgrade-mvc.js";
import { ArchiveDownloadModel, ArchiveDownloadView, ArchiveDownloadController } from "./archive-download-mvc.js";

/**********************************************************************
 * Content MVC
 *********************************************************************/

export class SoftwareContentModel extends IllumioEventEmitter {
    constructor() {
        super();

        this.currentElementId = null; // Example: content-pce_software_download
        this.currentContentId = null; // Example: pce_software_download
        
        this.contents = {};
    }
    
        /**
         * If the ID matches, instantiate the respective MVC and track them in the contents hash.
         */
        addContent() {
            this.currentElementId = SoftwareUtils.getCurrentContentId();
            if (this.currentElementId) {
                this.currentContentId = this.currentElementId.replace(/^content-/, '').replace(/-/, '_');
                if (!this.contents[this.currentContentId]) {
                    let model = null,
                        view = null,
                        controller = null;
                    switch (this.currentContentId) {
                        case 'pce_software_download':
                        case 'flowlink_download':
                        case 'compatibility_matrix_download':
                        case 'lwven_download':
                        case 'k8s_download':
                        case 'ven_download':
                        case 'nen_download':
                        case 'cli_download':
                            console.debug('SoftwareContentModel: addContent(): Download with version options and asset listing');
                            model = new SoftwareDownloadModel(this.currentContentId);
                            view = new SoftwareDownloadView(model);
                            controller = new SoftwareDownloadController(model, view);
                            break;
                        case 'pce_software_upgrade':
                        case 'ven_upgrade':
                            console.debug('SoftwareContentModel: addContent(): Upgrade with asset listing and upgrade path');
                            model = new SoftwareUpgradeModel(this.currentContentId);
                            view = new SoftwareUpgradeView(model);
                            controller = new SoftwareUpgradeController(model, view);
                            break;
                        case 'archive_download':
                            console.debug('SoftwareContentModel: addContent(): Download with asset listing without version options');
                            model = new ArchiveDownloadModel(this.currentContentId);
                            view = new ArchiveDownloadView(model);
                            controller = new ArchiveDownloadController(model, view);
                            break;                        
                        case 'custom_download':
                            console.debug('SoftwareContentModel: addContent(): Download with asset listing without version options');
                            model = new CustomDownloadModel(this.currentContentId);
                            view = new CustomDownloadView(model);
                            controller = new CustomDownloadController(model, view);
                            break;
                        default:
                            console.warn('SoftwareContentModel: addContent(): Unrecognized contentId ' + this.currentContentId);
                    }
                    if (this.currentContentId.match(/^(pce_software|ven)_upgrade$/)) {
                        const hashParts = location.hash.split('/');
                        if (hashParts.length>=3) {
                            model.fromVersion = hashParts[2];
                        }
                        if (hashParts.length>=4) {
                            model.toVersion = hashParts[3];
                        }
                    }
                    
                    if (model && view && controller) {
                        this.contents[this.currentContentId] = {
                            model: model,
                            view: view,
                            controller: controller,
                        }
                        console.debug(`SoftwareContentModel: addContent(): Successfully added contentId ${this.currentContentId} to the contents:`);
                        console.debug(this.contents[this.currentContentId]);
                    }
                } else {
                    console.debug(`SoftwareContentModel: The content for contentId ${this.currentContentId} exists. No further action!`);
                }
            }
        }
}

export class SoftwareContentView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        
        // this.toggleContentEvent = new IllumioEvent(this);
        // this.toggleDefaultContentEvent = new IllumioEvent(this);
    }
    
        /**
         * A utility function to toggle content div. 
         * Also use as a handler since it is independent from the event and 'this' arguments.
         */
        toggleContent() {
            // Hide currently display content
            const activeContentElements = document.getElementsByClassName('active-content');
            let currentActiveContentId = (activeContentElements.length>0) ? activeContentElements[0].id : null;
            let newActiveContentId = SoftwareUtils.getCurrentContentId();
            
console.debug(activeContentElements);
console.debug(`» currentActiveContentId: ${currentActiveContentId}`);
console.debug(`» newActiveContentId: ${newActiveContentId}`);
            if (newActiveContentId) {
                if (currentActiveContentId===newActiveContentId) {
                    console.debug(`SoftwareContentView: toggleContent(): There is no change content ID (${currentActiveContentId} vs ${newActiveContentId}).`);
                } else {
                    // Hide all elements of active-content. Remove the the classname from the element as well.
                    if (activeContentElements.length>0) {
                        for (let i=activeContentElements.length-1;i>=0;i--) {
                            activeContentElements[i].classList.add('hidden');
                            activeContentElements[i].classList.remove('active-content');
                        }
                    }
                    
                    // Show target content
                    console.debug(`Activate newActiveContentId: ${newActiveContentId}`);
                    
                    const contentElement = document.getElementById(newActiveContentId);
                    if (contentElement) {
                        contentElement.classList.remove('hidden');
                        contentElement.classList.add('active-content');
                    }
                    
                    this.model.addContent();
                }
                
                newActiveContentId = newActiveContentId.replace(/^content\-/, '').replace('-', '_');
                if (this.model.contents[newActiveContentId]) {
                    this.model.contents[newActiveContentId].view.render();
                } else {
                    // The content Id does not exist in the content hash. Let's trigger the default content.
                    this.emit('toggleDefaultContent', {});
                    // this.toggleDefaultContentEvent.notify();
                }
                
                console.debug(`ConventView: toggleContent(): Toggled ${newActiveContentId}`);
            } else {
                console.debug('SoftwareContentView: toggleContent(): newActiveContentId is undetermined. Toggle default content.');
                this.emit('toggleDefaultContent', {});
                // this.toggleDefaultContentEvent.notify();
            }
        }
        
        renderContent() {
            console.debug(`ConventView: renderContent()`);
            console.debug(`this.model.currentContentId: ${this.model.currentContentId}`);
            console.debug(this.model.contents);
            if (this.model.contents && this.model.currentContentId && this.model.contents[this.model.currentContentId]) {
                const content = this.model.contents[this.model.currentContentId];
                content.view.render();
            }
        }
}

export class SoftwareContentController extends IllumioEventEmitter {
    constructor(model, view, softwareNavigationController) {
        super();

        this.model = model;
        this.view = view;
        this.view.on('toggleContent', this.toggleContentEventHandler.bind(this));
        this.view.on('toggleDefaultContent', this.toggleDefaultContentEventHandler.bind(this));
        // this.view.toggleContentEvent.attach(toggleContentEventHandler.bind(this));
        // this.view.toggleDefaultContentEvent.attach(toggleDefaultContentEventHandler.bind(this));

        this.softwareNavigationController = softwareNavigationController;
        
        window.addEventListener('hashchange', this.locationHashChangeHandler.bind(this));
        
        // const navigationModel = new SoftwareNavigationModel();
        // const navigationView = new SoftwareNavigationView(navigationModel);
        // navigationView.setSoftwareContentView(this.view);
        // this.navigationController = new SoftwareNavigationController(navigationModel, navigationView);
        
        // Note: As of 2019-05-06: We have decided not to place the download button in the template. 
        //       Let's keep the code here should we choose to do so in the future.
        // Trigger Navigagtion MVC to default download content (if location hash is missing) or highlight navigation (if location hash is present)
        // Use interval just in case the this.softwareNavigationController is missing. 
        this.navigationController = null;
        let intervalId = null;
        let intervalCounter = 0; 
        let intervalMaxCounter = 60;
        const intervalHandler = function() {
        	// console.debug('SoftwareContentController: intervalId: ' + intervalId);
        	
        	// Expires the interval if the IllumioSupportTemplace.softwareNavigationController is still not detected 
        	// after 60 intervals of 250ms (15 seconds)
        	if (this.softwareNavigationController) {
                // this.softwareNavigationController.view.contentLoadEvent.notify();
                this.softwareNavigationController.view.emit('loadContent', {});
                clearInterval(intervalId);
                // console.info('SoftwareContentController: Clear interval ' + intervalId);
        	} else if (intervalCounter>intervalMaxCounter) {
                clearInterval(intervalId);
                console.warn('SoftwareContentController: Clear interval ' + intervalId + ' after ' + intervalMaxCounter + ' intervals.');
            } else {
                // console.debug('SoftwareContentController: Download navigation controller undetected. (' + intervalCounter + ')');
            }
            intervalCounter++;
        }
        intervalId = setInterval(intervalHandler.bind(this), 250);
        console.debug('SoftwareContentController: inveralId is ' + intervalId);
        
        this.view.toggleContent();
    }
    
    locationHashChangeHandler(event) {
        this.view.emit('toggleContent', {});
        // this.view.toggleContentEvent.notify(event);
    }
    
    /**
     * Event handler for this.view.toogleContentEvent. 
     * Assumption: When hash is changed, the newURL and oldURL in the event object will always be different. 
     */
    toggleContentEventHandler() {
        console.debug(this);
        this.view.toggleContent();

        if (this.softwareNavigationController) {
            this.softwareNavigationController.updateAnchorElement();
        }
    }
    
    /**
     * Event handler for this.view.toggleDefaultContentEvent.
     */
    toggleDefaultContentEventHandler = function() {
console.debug(this.softwareNavigationController);
        if (this.softwareNavigationController) {
            this.softwareNavigationController.view.clickDefaultNavigationLink();
        }
    }
    
};
